import styled from 'styled-components';
import Card from '@designSystem/Card';
import { Modal } from 'react-bootstrap';

export const ConfirmAddressText = styled(Card)<{ color: string }>`
  --color: ${(props) => props.color};
  padding-left: 8px;
  height: 50px;
  width: 100%;
  justify-content: center;
  text-align: center;
  background-color: rgba(var(--color), 0.2);
  color: rgba(var(--color));
  font-weight: 600;
  > div {
    padding: 8px 12px;
  }
`;

export const ConfirmSeparator = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin: 10px 0 10px;
`;

export const ConfirmArrowsIcon = styled.span`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #dee2e6;
  text-align: center;
  display: flex;
  padding: 8px;
  justify-content: center;
`;

export const ConfirmModalText = styled.span`
  font-weight: 600;
  font-size: small;
`;

export const ConfirmStyledHeader = styled(Modal.Header)`
  text-align: center;
  .modal-title {
    font-size: medium;
  }
`;

export const ConfirmModalBody = styled(Modal.Body)`
  padding: 10px;
`;

export const ConfirmCustomCard = styled(Card)`
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ConfirmStyledFooter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const ConfirmCustomBody = styled.div`
  justify-content: center;
  padding: 24px;
`;
